import { createApp } from 'vue';
import Dropdown from "./Dropdown.vue";

const els = document.querySelectorAll(".js-dropdown");
els.forEach((el) => {
  const app = createApp(Dropdown, {
    options: JSON.parse(el.dataset.options),
    selected: el.dataset.selected
  });
  app.mount(el);
})